import Script from "next/script";

const Gtm = () => {
  if (process.env.NODE_ENV === "production") {
    return (
      <Script
        id="gtm"
        type="text/plain"
        data-category="analytics"
        data-service="Google Tag Manager"
      >
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-W288SMRC');
        `}
      </Script>
    );
  }
  return null;
};

export { Gtm };
